module.exports = __webpack_public_path__ + "static/img/tnB_1.e28e4bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/tnB_1.png
// module id = 1285
// module chunks = 1